module.exports = __webpack_public_path__ + "static/img/10.0b46145.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/10.png
// module id = vtd/
// module chunks = 0